import { formatDateVerbose, parseAirDateToISO } from '@air/utilities';

const DATE_TIME_FORMAT: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  month: 'short',
  year: 'numeric',
};

const DATE_TIME_FORMATTER = new Intl.DateTimeFormat('en-US', DATE_TIME_FORMAT);

export const formatListViewDate = (value: string | undefined, includeTime = false) => {
  if (!value) {
    return undefined;
  }

  try {
    const date = parseAirDateToISO(value);

    if (Number.isNaN(date.getTime())) {
      return undefined;
    }

    if (!includeTime) {
      return formatDateVerbose(value);
    }

    return DATE_TIME_FORMATTER.format(date);
  } catch {
    return undefined;
  }
};
